/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const logger = require('@gral/log');
const k = require('@gral/constants');
const act = require('../actions/actDispatcher');
const Action = require('../actions/action');

const log = logger('ACT: VIEW');

const _relayNewAction = (type, data) => act.relay(new Action({ type, data, source: k.actionSources.VIEW }));

module.exports = {
  relay(action) {
    return act.relay(action);
  },

  fetch(rsrc) {
    log.info(`#${Action.seq()}: Fetch data: ${rsrc.url} -> ${rsrc.dataPath}`);
    return _relayNewAction('FETCH', rsrc);
  },

  push(data) {
    log.info(`#${Action.seq()}: Push data to: ${data.url}`);
    return _relayNewAction('PUSH', data);
  },

  fetchMultiple(rsrcs) {
    log.info(`#${Action.seq()}: Fetch multiple resources: ${_.map(rsrcs, 'dataPath').join(', ')}`);
    return _relayNewAction('FETCH_MULTIPLE', rsrcs);
  },

  create(rsrc) {
    log.info(`#${Action.seq()}: Create: ${rsrc.url} -> ${rsrc.dataPath}`);
    return _relayNewAction('CREATE', rsrc);
  },

  copy(rsrc) {
    log.info(`#${Action.seq()}: Copy: ${rsrc.url} -> ${rsrc.dataPath}`);
    return _relayNewAction('COPY', rsrc);
  },

  update(rsrc) {
    log.info(`#${Action.seq()}: Update: ${rsrc.url} -> ${rsrc.dataPath}`);
    return _relayNewAction('UPDATE', rsrc);
  },

  decommissionOld(rsrc) {
    log.info(`#${Action.seq()}: DecommissionOld: ${rsrc.url}`);
    return _relayNewAction('DECOMMISSION_OLD', rsrc);
  },

  logIn(userAttrs) {
    log.info(`#${Action.seq()}: Log in as ${userAttrs.login}`);
    return _relayNewAction('LOGIN_START', userAttrs);
  },

  logOut() {
    log.info(`#${Action.seq()}: Log out`);
    return _relayNewAction('LOGOUT');
  },

  passwordRecovery(userAttrs) {
    log.info(`#${Action.seq()}: Recovering ${userAttrs.login} password`);
    return _relayNewAction('PASSWORD_RECOVERY', userAttrs);
  },

  passwordReset(userAttrs) {
    log.info(`#${Action.seq()}: Resetting password with token ${userAttrs.token}`);
    return _relayNewAction('PASSWORD_RESET', userAttrs);
  },

  setDataPath(dataPath, data) {
    log.info(`#${Action.seq()}: Setting ${dataPath}`);
    return _relayNewAction('SET_DATA_PATH', { dataPath, data });
  },

  deleteResource(dataPath) {
    log.info(`#${Action.seq()}: Delete resource ${dataPath}`);
    return _relayNewAction('DELETE_RESOURCE', dataPath);
  },

  markAsStale(dataPath) {
    log.info(`#${Action.seq()}: Mark as stale ${dataPath}`);
    return _relayNewAction('MARK_AS_STALE', dataPath);
  },

  goTo(routePath, options) {
    if (!routePath.startsWith('/')) {
      routePath = '/' + routePath;
    }
    if (options == null) {
      options = { cleanDatapath: true };
    }
    log.info(`#${Action.seq()}: Go to ${routePath}`);

    return _relayNewAction('GO_TO', { routePath, ...options });
  },

  notify(notifPars) {
    log.info(`Show notification: ${notifPars.msg}...`);
    return _relayNewAction('NOTIF_SHOW', notifPars);
  },

  notifDismiss(cid) {
    log.info(`#${Action.seq()}: Dismiss notification ${cid}`);
    return _relayNewAction('NOTIF_DISMISS', cid);
  },

  /*   upload(dataPath, data, file) {
    log.info(`#${Action.seq()}: Upload ${dataPath} (${data.name})`);
    return _relayNewAction('UPLOAD', { dataPath, data, file });
  }, */

  linkLayerToView(layerId, viewId, properties) {
    const dataPath = 'linkLayerToView';
    log.info(`#${Action.seq()}: Link layer to view`);
    return _relayNewAction('LINK_LAYER_TO_VIEW', {
      dataPath,
      data: { layerId, viewId, properties },
    });
  },

  unlinkLayerFromView(layerId, viewId) {
    const dataPath = 'unlinkLayerFromView';
    log.info(`#${Action.seq()}: Unlink layer from view`);
    return _relayNewAction('UNLINK_LAYER_FROM_VIEW', {
      dataPath,
      data: { layerId, viewId },
    });
  },

  linkRulesetToLayer(rulesetId, layerId) {
    const dataPath = 'linkRulesetToLayer';
    log.info(`#${Action.seq()}: Link ruleset to layer`);
    return _relayNewAction('LINK_RULESET_TO_LAYER', {
      dataPath,
      data: { rulesetId, layerId },
    });
  },

  unlinkRulesetFromLayer(rulesetId, layerId) {
    const dataPath = 'unlinkRulesetFromLayer';
    log.info(`#${Action.seq()}: Unlink ruleset from layer`);
    return _relayNewAction('UNLINK_RULESET_FROM_LAYER', {
      dataPath,
      data: { rulesetId, layerId },
    });
  },

  attachDevice(data) {
    const dataPath = 'attachDevice';
    log.info(`#${Action.seq()}: Attach device`);
    return _relayNewAction('ATTACH_DEVICE', { dataPath, data });
  },

  /*  detachDevice(deviceId, elementId, detachmentDate = null) {
     const dataPath = 'detachDevice';
     log.info(`#${Action.seq()}: Detach device`);
     return _relayNewAction('DETACH_DEVICE', {
       dataPath,
       data: { deviceId, elementId, detachmentDate },
     });
   }, */

  attachSensor(sensorId, elementId, attachmentStreamParams, deviceName, attachmentDate = null) {
    const dataPath = 'attachSensor';
    log.info(`#${Action.seq()}: Attach sensor`);
    return _relayNewAction('ATTACH_SENSOR', {
      dataPath,
      data: {
        deviceName,
        sensorId,
        elementId,
        attachmentStreamParams,
        attachmentDate,
      },
    });
  },

  detachSensor(sensorId, elementId, detachmentDate = null) {
    const dataPath = 'detachSensor';
    log.info(`#${Action.seq()}: Detach sensor`);
    return _relayNewAction('DETACH_SENSOR', {
      dataPath,
      data: { sensorId, elementId, detachmentDate },
    });
  },

  unsetParameter(parameterId, type, xTypeId = null) {
    const dataPath = 'unsetParameter';
    log.info(`#${Action.seq()}: Unset parameter`);
    return _relayNewAction('UNSET_PARAMETER', {
      dataPath,
      data: { parameterId, type, xTypeId },
    });
  },

  decommission(parameterId, type, xTypeId = null) {
    const dataPath = 'decommission';
    log.info(`#${Action.seq()}: Unset parameter`);
    return _relayNewAction('DECOMMISSION', {
      dataPath,
      data: { parameterId, type, xTypeId },
    });
  },

  /*   changeMainSidebarState(data) {
      log.info(`#${Action.seq()}: Main sidebar state changed`);
      return _relayNewAction('CHANGE_MAIN_SIDEBAR_STATE', data);
    }, */
};
